import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useIsMobile } from "@src/appV2/redesign/AppLayout/useResponsive";

import { useIsDailyViewEnabled } from "./useIsDailyViewEnabled";

/**
 * Returns true when the user should be redirected to /schedule on login.
 *
 * All three conditions must be met:
 * 1. The viewport is mobile-sized
 * 2. The redirect feature flag is enabled
 * 3. The Daily View feature itself is enabled (DAILY_VIEW_ENABLED)
 *
 * Checking DAILY_VIEW_ENABLED prevents a redirect loop: without it the user
 * would land on /schedule, DailyView.tsx would redirect to /calendar, and
 * the catch-all would send them back to /schedule.
 */
export function useShouldRedirectToDailyView(): boolean {
  const isMobile = useIsMobile();
  const isRedirectEnabled = useCbhFlag(CbhFeatureFlag.WORKPLACE_APP_MOBILE_DAILY_VIEW_REDIRECT, {
    defaultValue: false,
  });
  const isDailyViewEnabled = useIsDailyViewEnabled();

  return isMobile && isRedirectEnabled && isDailyViewEnabled;
}
